var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartola(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.647,
    height: 22.196,
    viewBox: "0 0 16.647 22.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invoice",
    transform: "translate(-64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2214",
    "data-name": "Grupo 2214",
    transform: "translate(75.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2213",
    "data-name": "Grupo 2213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3479",
    "data-name": "Trazado 3479",
    d: "M320,0V5.549h5.549Z",
    transform: "translate(-320)",
    fill: "#0056a3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2216",
    "data-name": "Grupo 2216",
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2215",
    "data-name": "Grupo 2215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3480",
    "data-name": "Trazado 3480",
    d: "M75.1,6.936a1.39,1.39,0,0,1-1.387-1.387V0H65.387A1.39,1.39,0,0,0,64,1.387V20.809A1.389,1.389,0,0,0,65.387,22.2H79.26a1.388,1.388,0,0,0,1.387-1.387V6.936ZM68.855,4.248v-.78a.694.694,0,1,1,1.387,0v.781a2.851,2.851,0,0,1,1.174.554.693.693,0,1,1-.875,1.075,1.575,1.575,0,0,0-.992-.329c-.752,0-1.387.476-1.387,1.04s.635,1.04,1.387,1.04a2.621,2.621,0,0,1,2.775,2.428A2.511,2.511,0,0,1,70.243,12.4v.78a.694.694,0,1,1-1.387,0V12.4a2.851,2.851,0,0,1-1.174-.554.694.694,0,0,1,.875-1.077,1.567,1.567,0,0,0,.992.33c.752,0,1.387-.476,1.387-1.04s-.635-1.04-1.387-1.04A2.621,2.621,0,0,1,66.775,6.59,2.511,2.511,0,0,1,68.855,4.248Zm8.324,12.4H67.468a.694.694,0,1,1,0-1.387h9.711a.694.694,0,0,1,0,1.387Zm0-2.775H74.4a.694.694,0,0,1,0-1.387h2.775a.694.694,0,1,1,0,1.387Zm0-2.775H74.4a.694.694,0,0,1,0-1.387h2.775a.694.694,0,0,1,0,1.387Z",
    transform: "translate(-64)",
    fill: "#0056a3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartola);
export default __webpack_public_path__ + "static/media/cartola.46c6cb14adcee9e85c4444fbd47bcd7e.svg";
export { ForwardRef as ReactComponent };